import currentReleaseInfo from "@/../release-info.json"
import { fetchLatestReleaseInfo } from "@/apis/release-info"

export const getHasReleaseChanged = async () => {
  const latestReleaseInfo = await fetchLatestReleaseInfo()
  return currentReleaseInfo.sourceCommit !== latestReleaseInfo.sourceCommit
}
